import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FuseLoadingBarComponent } from '../../@fuse/components/loading-bar/loading-bar.component';
import { takeUntil } from 'rxjs';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingService } from '@fuse/services/loading';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Extension OnPush du FuseLoadingBarComponent
 * 
 * Ce composant hérite de FuseLoadingBarComponent et ajoute la gestion
 * de la détection de changements pour les composants OnPush.
 * 
 * Usage: Remplacer <fuse-loading-bar> par <app-loading-bar-onpush> dans les layouts OnPush
 */
@Component({
    selector: 'app-loading-bar-onpush',
    templateUrl: './loading-bar-onpush.component.html',
    styleUrls: ['./loading-bar-onpush.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [MatProgressBarModule],
})
export class LoadingBarOnPushComponent extends FuseLoadingBarComponent implements OnInit {
    private _cdr = inject(ChangeDetectorRef);
    private destroyRef = inject(DestroyRef);

    private _fuseLoadingServiceLocal = inject(FuseLoadingService);

    override ngOnInit(): void {
        // Appeler l'init parent
        super.ngOnInit();

        // Ajouter markForCheck pour OnPush sur chaque changement
        this._fuseLoadingServiceLocal.mode$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this._cdr.markForCheck();
            });

        this._fuseLoadingServiceLocal.progress$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this._cdr.markForCheck();
            });

        this._fuseLoadingServiceLocal.show$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this._cdr.markForCheck();
            });
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
